import React from 'react';
import { motion } from 'framer-motion';
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}
const CART_URL = 'https://templodigital.shop/cart/42690056749127:1';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function CTAButton({
  children,
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_ids: ['7502545616967'],
        content_type: 'product',
        value: 19990,
        currency: 'ARS'
      });
    }
  };
  return <motion.a href={CART_URL} target="_blank" rel="noopener noreferrer" onClick={handleClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        inline-flex items-center justify-center 
        bg-accent text-white font-bold text-lg md:text-xl
        py-4 px-8 rounded-xl shadow-lg
        hover:bg-opacity-90 hover:shadow-xl
        transition-all duration-300
        w-full md:w-auto text-center
        animate-pulse-slow
        ${className}
      `} data-id="element-42">
      {children}
    </motion.a>;
}